import type { Opportunity } from '../../types/workbench'
import { OpportunityCard } from './WorkbenchParts'

// The openings at this account, as the API read them: the situation, the service line it points at, the people
// in it, and where the reading came from. Selecting one is a turn of the conversation ("Work the X opening"),
// so the draft and the diagram follow it the same way they follow anything else said. An opening is a proposal;
// "Make this an opportunity" hands it to the opportunity panel's form to be stored as one (REQ-121).

export function Opportunities({ opportunities, selectedId, onSelect, onMake, busy = false }: {
  opportunities: Opportunity[]; selectedId: string | null; onSelect: (o: Opportunity) => void; onMake?: (o: Opportunity) => void; busy?: boolean
}) {
  if (opportunities.length === 0) return <p className="muted small">No opening read at this account yet — the relationship is the reason to write.</p>
  return (
    <ul className="plain opportunity-list">
      {opportunities.map((o) => <OpportunityCard key={o.id} o={o} selected={o.id === selectedId} onSelect={busy ? undefined : () => onSelect(o)} onMake={onMake && !busy ? () => onMake(o) : undefined} />)}
    </ul>
  )
}
